import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './TopBanner.css';
import IAIcon from '../../../assets/svgs/AI-icon-white.svg';

const TopBanner = ({ onVisibilityChange, bannerKey }) => {
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const setLocalStorageWithEvent = (key, value) => {
    localStorage.setItem(key, value);
    window.dispatchEvent(
      new CustomEvent('localStorageChange', {
        detail: { key, value },
      }),
    );
  };

  useEffect(() => {
    const alreadyClosed = localStorage.getItem(bannerKey);
    const isPesquisaPage =
      location.pathname.endsWith('/resultados') ||
      location.pathname.endsWith('/login');

    const shouldShow = !alreadyClosed && !isPesquisaPage;
    setVisible(shouldShow);

    if (onVisibilityChange) {
      onVisibilityChange(shouldShow);
    }
  }, [location.pathname, bannerKey]);

  const handleClose = () => {
    // localStorage.setItem(bannerKey, 'true');
    setLocalStorageWithEvent(bannerKey, 'true');

    setVisible(false);
    if (onVisibilityChange) {
      onVisibilityChange(false);
    }
  };

  if (!visible) return null;

  return (
    <div className="top-banner">
      <div className="banner-content">
        <img src={IAIcon} alt="IA" className="icon" />
        <span>
          Funcionalidades de resumos com IA liberadas para você até 30 de junho
        </span>
      </div>
      <button onClick={handleClose} className="close-button">
        ✕
      </button>
    </div>
  );
};

export default TopBanner;
